import ServiceProviders from './ServiceProviders';

export default ServiceProviders; 


// WEBPACK FOOTER //
// ./resources/assets/js/components/ServiceProviders/index.js